export const TEMP_EVENT_ID = 'temporary'
